// src/components/Console/Staff/roles/ReceptionTasks/pages/ReceptionBookingSummary.jsx
import React from 'react';
import moment from 'moment-timezone';
import './ReceptionBookingSummary.css';

function normalizeSelectedPets(petsRaw) {
  if (!petsRaw) return [];
  if (Array.isArray(petsRaw)) return petsRaw;
  try {
    var parsed = JSON.parse(petsRaw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
}

function summarizeDay(list) {
  var summary = {
    total: 0,
    byType: {},
    byStatus: {},
    firstTime: null,
    lastTime: null,
    guests: 0,
    unassigned: 0,
    uniqueClients: 0,
    revenueOriginal: 0,
    revenueDiscounted: 0
  };
  if (!Array.isArray(list)) return summary;

  var userSet = {};
  for (var i = 0; i < list.length; i++) {
    var b = list[i];
    if (!b) continue;

    summary.total += 1;

    var t = b.bookingType ? b.bookingType : 'Other';
    if (!summary.byType[t]) summary.byType[t] = 0;
    summary.byType[t] = summary.byType[t] + 1;

    var s = b.status ? b.status : 'Unknown';
    if (!summary.byStatus[s]) summary.byStatus[s] = 0;
    summary.byStatus[s] = summary.byStatus[s] + 1;

    var ts = b.startTime ? new Date(b.startTime).getTime() : null;
    if (ts) {
      if (summary.firstTime === null || ts < summary.firstTime) summary.firstTime = ts;
      if (summary.lastTime === null || ts > summary.lastTime) summary.lastTime = ts;
    }

    var pets = normalizeSelectedPets(b.selectedPets);
    summary.guests += Array.isArray(pets) ? pets.length : 0;

    if (!b.assignedTo) summary.unassigned += 1;

    if (b.userId) userSet[b.userId] = true;
    summary.revenueOriginal += Number(b.originalPrice || 0);
    summary.revenueDiscounted += Number(b.discountedPrice || 0);
  }
  summary.uniqueClients = Object.keys(userSet).length;
  return summary;
}

function fmtTime(ts) {
  try { return ts ? moment(ts).format('h:mm A') : '--'; }
  catch (e) { return '--'; }
}

const ReceptionBookingSummary = function (props) {
  var dateISO = props && props.dateISO ? props.dateISO : null;
  var bookings = props && props.bookings ? props.bookings : [];
  var incomingSummary = props && props.summary ? props.summary : null;
  var activeFilter = props && props.activeFilter ? props.activeFilter : { kind: 'all', value: null };
  var onFilter = props && props.onFilter ? props.onFilter : function () {};

  // If parent didn’t provide a precomputed whole-day summary, build from given list
  var summary = incomingSummary ? incomingSummary : summarizeDay(bookings);

  function isActive(kind, value) {
    if (!activeFilter) return false;
    if (activeFilter.kind === 'all' && kind === 'all') return true;
    return activeFilter.kind === kind && String(activeFilter.value) === String(value);
  }

  function handleAllClick() {
    onFilter({ kind: 'all', value: null });
  }

  function handleTypeClick(val) {
    onFilter({ kind: 'type', value: val });
  }

  function handleStatusClick(val) {
    onFilter({ kind: 'status', value: val });
  }

  return (
    <div className="day-summary">
      <div className="day-summary-row">
        <div className="ds-card">
          <div className="ds-label">Total</div>
          <div className="ds-value">{summary.total}</div>
        </div>
        <div className="ds-card">
          <div className="ds-label">Guests</div>
          <div className="ds-value">{summary.guests}</div>
        </div>
        <div className="ds-card">
          <div className="ds-label">Unassigned</div>
          <div className="ds-value">{summary.unassigned}</div>
        </div>
        {/* <div className="ds-card">
          <div className="ds-label">Window</div>
          <div className="ds-value">
            {fmtTime(summary.firstTime)} – {fmtTime(summary.lastTime)}
          </div>
        </div> */}
      </div>

      {/* Chips row — with All, then Type chips, then Status chips */}
      <div className="day-summary-row wrap">
        <button
          type="button"
          className={'ds-chip ds-chip-all' + (isActive('all', null) ? ' active' : '')}
          onClick={handleAllClick}
        >
          <span className="ds-chip-key">All</span>
          <span className="ds-chip-value">{summary.total}</span>
        </button>

        {Object.keys(summary.byType).map(function (key) {
          return (
            <button
              type="button"
              key={'type-' + key}
              className={'ds-chip' + (isActive('type', key) ? ' active' : '')}
              onClick={function () { handleTypeClick(key); }}
              title={'Filter by ' + key}
            >
              <span className="ds-chip-key">{key}</span>
              <span className="ds-chip-value">{summary.byType[key]}</span>
            </button>
          );
        })}

        {Object.keys(summary.byStatus).map(function (key) {
          return (
            <button
              type="button"
              key={'status-' + key}
              className={'ds-chip ds-chip-alt' + (isActive('status', key) ? ' active' : '')}
              onClick={function () { handleStatusClick(key); }}
              title={'Filter by ' + key}
            >
              <span className="ds-chip-key">{key}</span>
              <span className="ds-chip-value">{summary.byStatus[key]}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default ReceptionBookingSummary;
